<script lang="ts">
  import { onMount } from "svelte";
  import { Link } from "svelte-routing";
  import Header from "./Header.svelte";
  import Footer from "./Footer.svelte";

  onMount(() => {
    document.title = "wiederdabei — Seite nicht gefunden";
    document.body.dataset.nav = "";
  });
</script>

<Header active="" />
<main>
  <section class="section">
    <div class="wrap" style="text-align:center; padding-block:clamp(60px,10vw,120px)">
      <p class="eyebrow">404</p>
      <h1>Seite nicht gefunden</h1>
      <p style="color:var(--muted); max-width:46ch; margin:16px auto 28px">
        Diese Seite existiert nicht oder wurde verschoben.
      </p>
      <Link to="/" class="btn btn--primary">Zur Startseite</Link>
    </div>
  </section>
</main>
<Footer />
